"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import React from "react";
import * as Pb from "../data/types/Pb";
import DataStoreService from "../data_store_service";
import $ from "jquery";
import { DocumentBrowserUpdateNotifier } from "../grouped_document_browser_model";
import { maybeSetupOcrTextDrop } from "./ocr_text_drop";
export class EmbeddedElmComponent extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "dropContainer", null);
    __publicField(this, "elmContainer", null);
    __publicField(this, "elmApp", null);
    __publicField(this, "teardownOcrTextDrop", null);
    __publicField(this, "handleDocumentPageReplaced", (event, documentPage) => {
      var _a, _b;
      if ((_b = (_a = this.elmApp) == null ? void 0 : _a.ports) == null ? void 0 : _b.pusherDocumentPageUpdate) {
        this.elmApp.ports.pusherDocumentPageUpdate.send({});
      }
    });
  }
  componentDidMount() {
    var _a, _b, _c, _d;
    if (!this.elmContainer) {
      return;
    }
    const Elm = window.Elm;
    if (Elm && Elm.EmbeddedComponents) {
      const encodedFlags = Pb.encodeEmbeddedComponentsFlags(
        this.props.componentFlags
      );
      this.elmApp = Elm.EmbeddedComponents.init({
        node: this.elmContainer,
        flags: {
          initialLocation: window.location.href,
          mainFlags: encodedFlags
        }
      });
      (_b = (_a = this.elmApp.ports) == null ? void 0 : _a.updateDataStore) == null ? void 0 : _b.subscribe((responseData) => {
        DataStoreService.responseHandler(responseData);
      });
      (_d = (_c = this.elmApp.ports) == null ? void 0 : _c.selectDocumentPage) == null ? void 0 : _d.subscribe(
        (documentPageId) => {
          $(DocumentBrowserUpdateNotifier).trigger("selectPage", [
            documentPageId
          ]);
        }
      );
      $(DataStoreService).on(
        "DataStoreService:documentPageReplaced",
        this.handleDocumentPageReplaced
      );
      this.teardownOcrTextDrop = maybeSetupOcrTextDrop(
        this.props.componentFlags,
        this.dropContainer,
        this.elmApp
      );
    } else {
      console.error(
        "Elm.EmbeddedComponents not found. Make sure webpack compiled the Elm bundle."
      );
    }
  }
  componentWillUnmount() {
    var _a;
    $(DataStoreService).off(
      "DataStoreService:documentPageReplaced",
      this.handleDocumentPageReplaced
    );
    (_a = this.teardownOcrTextDrop) == null ? void 0 : _a.call(this);
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { ref: (el) => this.dropContainer = el }, /* @__PURE__ */ React.createElement("div", { ref: (el) => this.elmContainer = el }));
  }
}
